module.exports = __webpack_public_path__ + "static/img/bg_blur.ec1084d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_blur.jpg
// module id = r7QB
// module chunks = 6